import { Droppable, DroppableProps } from "@hello-pangea/dnd";
import { useEffect, useState } from "react";

export const StrictModeDroppable = ({ children, ...props }: DroppableProps) => {
    const [enabled, setEnabled] = useState(false);

    useEffect(() => {
        const animation = requestAnimationFrame(() => setEnabled(true));
        return () => {
            cancelAnimationFrame(animation);
            setEnabled(false);
        };
    }, []);

    return enabled ? <Droppable {...props}>{children}</Droppable> : null;
};
